import styles from './DynImage.module.scss'
// import { useState } from "react"
import { useEffect, useState } from 'react'
import usePrefStore from '../stores/prefs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAperture } from '@fortawesome/pro-light-svg-icons'

function DynImage(props) {
   const [myImg, setMyImg] = useState<any>(false)
   const [fromByMessika, setFromByMessika] = useState<any>(false)
   const [loading, setLoading] = useState(false)
   //
   // const imgSourcePrio = usePrefStore((state) => state.imgSourcePrio);
   // const showImageSource = usePrefStore((state) => state.showImageSource);
   const { imgSourcePrio, showImageSource } = usePrefStore()

   // const checkImage = (path) => {
   //    // console.log('CHECK_IMAGE', path, props);
   //    return new Promise((resolve, reject) => {
   //       const img = new Image();
   //       img.onload = () => resolve(path);
   //       img.onerror = (err) => reject({ err, path });
   //       img.src = path;
   //    });
   // };
   // Nv version de checkImage qui permet de passer la main au sw pour que le staleWhileRevalidate() fasse son œuvre
   const checkImage = async (path: string): Promise<string> => {
      const res = await fetch(path, { cache: 'no-cache' })
      if (!res.ok) throw new Error(`Image load failed: ${res.status} - ${path}`)
      const ct = res.headers.get('content-type')
      if (!ct || !ct.startsWith('image/')) throw new Error(`Not an image: ${path}`)
      return path
   }

   // Décompose props.src en valeurs primitives stables pour ne pas re-fire l'useEffect
   // à chaque render parent (qui crée toujours un nouveau tableau pour `src`).
   const src0 = Array.isArray(props.src) ? props.src[0] : null
   const src1 = Array.isArray(props.src) ? props.src[1] : null

   useEffect(() => {
      if (src0 || src1) {
         let arr
         if (!src0 && src1) {
            arr = [`https://www.bymessika.com/media/catalog/product${src1}`, null]
         } else if (imgSourcePrio === 'internal' || !src1) {
            arr = [src0, src1]
         } else {
            arr = [`https://www.bymessika.com/media/catalog/product${src1}`, src0]
         }
         let cancelled = false
         setLoading(true)
         checkImage(arr[0])
            .then((path) => {
               if (cancelled) return
               setLoading(false)
               setMyImg(path)
               setFromByMessika(imgSourcePrio !== 'internal')
            })
            .catch(() => {
               if (cancelled) return
               if (arr[1]) {
                  checkImage(arr[1])
                     .then((path) => {
                        if (cancelled) return
                        setLoading(false)
                        setMyImg(path)
                        setFromByMessika(imgSourcePrio === 'internal')
                     })
                     .catch(() => {
                        if (cancelled) return
                        setLoading(false)
                     })
               } else {
                  setLoading(false)
               }
            })
         return () => { cancelled = true }
      }
   }, [src0, src1, imgSourcePrio])

   // <img src={props.src} className={styles.dynimage} alt={props.alt} />
   return (
      <div className={`${styles.dynimage} ${props.className} ${loading ? styles.loading : ''}`}>
         {myImg && <img src={myImg} alt={props.alt} />}
         {myImg && fromByMessika && showImageSource && <div className={styles.bymessika} />}
         {!myImg && <FontAwesomeIcon icon={faAperture} />}
         {/* <div className={styles.bymessika} /> */}
      </div>
   )
}

export default DynImage
